export class Scc {
    public sistemaCobranca: number;
	public contratoCobranca: number;
}

export class Endi extends Scc {
	public cnpjAgente: string;
	public cnpjOuCpfBeneficiarioFinal: string;
	public identificadorUnidadeMonetaria: string;
	public codigoFonteRecursos: string;
	public modalidade: string;
}

export class Movi extends Scc {
    public ideEventoScc: any;
    public valorEmReais: number;
    public valorEmUnidadeMonetaria: number;
	public dataCompetencia: Date;
	public dataPagamento: Date;
    public dataRegistro: Date;
}

export class Sald extends Scc {
    public valorEmUnidadeMonetaria: number;
	public dataCompetencia: Date; 
}

export const EVENTO_SCC =[

    {
        codigo: '612',
        nome:"Amortização",
        sistemas: [15, 89]
    },
    {
        codigo: '019',
        nome:"Liberação",
        sistemas: [15, 89]
    },
    {
        codigo: '337',
        nome:"Juros Compensatórios",
        sistemas: [15, 89]
    },
    {
        codigo: '620',
        nome:"Liquidação antecipada",
        sistemas: [15, 89]
    },
    {
        codigo: '176',
        nome:"Honra Crédito Livre",
        sistemas: [84],
        modalidade: "PEAC"
    },
    {
        codigo: '186',
        nome:"Honra Repasse - Saldo vincendo",
        sistemas: [84],
        modalidade: "PEAC"
    },
    {
        codigo: '196',
        nome:"Honra Repasse - Parcelas vencidas",
        sistemas: [84],
        modalidade: "PEAC"
    },
    {
        codigo: '951',
        nome:"Recuperação de crédito - Repasse- Valor histórico",
        sistemas: [84],
        modalidade: "PEAC"
    },
    {
        codigo: '958',
        nome:"Recuperação de crédito - Crédito Livre - Valor histórico",
        sistemas: [84],
        modalidade: "PEAC"
    },
    {
        codigo: '178',
        nome:"Honra Crédito Livre",
        sistemas: [84],
        modalidade: "FG2"
    },
        {
        codigo: '188',
        nome:"Honra Repasse - Saldo vincendo",
        sistemas: [84],
        modalidade: "FG2"
    },
    {
        codigo: '198',
        nome:"Honra Repasse - Parcelas vencidas",
        sistemas: [84],
        modalidade: "FG2"
    },
        {
        codigo: '870',
        nome:"Recuperação de crédito - Repasse- Valor histórico",
        sistemas: [84],
        modalidade: "FG2"
    },
    {
        codigo: '871',
        nome:"Recuperação de crédito - Crédito Livre - Valor histórico",
        sistemas: [84],
        modalidade: "FG2"
    }
]	 